import { createEvent, createStore, sample } from 'effector';
import { $resetAuth } from './profile-entity';

export interface IPhoneListItem {
	id: number;
	clientId: string;
	buildId: string;

	number?: string | null;
	subId: string;
	name: string;
	status: 0 | 1 | 2 | 3 | number;

	takeStatus?: 0 | 1 | 2 | 3;
	takenFrom?: string;
	cardBalances?: number[];

	createdAt: string;
}

export const $resetPanelState = createEvent();

export const $setIsFetchingPhones = createEvent<boolean>();
export const $isFetchingPhones = createStore<boolean>(false).on($setIsFetchingPhones, (_, payload) => payload).reset($resetPanelState);

export const $setHasMorePhones = createEvent<boolean>();
export const $hasMorePhones = createStore<boolean>(false).on($setHasMorePhones, (_, payload) => payload).reset($resetPanelState);

export const $setCursorPhones = createEvent<string | null>();
export const $cursorPhones = createStore<string | null>(null).on($setCursorPhones, (_, payload) => payload).reset($resetPanelState);

export const $setPhones = createEvent<IPhoneListItem[]>();
export const $addPhones = createEvent<IPhoneListItem[]>();
export const $updatePhonesByClientId = createEvent<Partial<IPhoneListItem> & { clientId: string }>();

export const $phones = createStore<IPhoneListItem[]>([])
	.on($setPhones, (_, payload) => payload)
	.on($addPhones, (state, payload) => {
		return [...state, ...payload];
	})
	.on($updatePhonesByClientId, (state, payload) => {
		const newState = state.map(item => {
			if (item?.clientId === payload?.clientId) return { ...item, ...{ ...payload, id: item.id } };
			else return item;
		});

		return [...newState];
	})
	.reset($resetPanelState);

sample({
	clock: $resetAuth,
	target: $resetPanelState,
});
